"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnOrderReason = void 0;
var ReturnOrderReason;
(function (ReturnOrderReason) {
    ReturnOrderReason["CR06"] = "ItemSwap";
    ReturnOrderReason["CR09"] = "Never";
    ReturnOrderReason["CR11"] = "Others";
    ReturnOrderReason["CR13"] = "Closing";
    ReturnOrderReason["CR15"] = "EventItems";
    ReturnOrderReason["CR16"] = "EndOfSeasn";
    ReturnOrderReason["CR10"] = "Incorrect";
    ReturnOrderReason["WarrantyDefault"] = "Return";
})(ReturnOrderReason = exports.ReturnOrderReason || (exports.ReturnOrderReason = {}));
//# sourceMappingURL=return-order-reason.js.map